"use client";

import React from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import ImageComponent from "@/components/ui/image";
import styles from "./MobileCategories.module.css";
import { sendGAEvent } from "@next/third-parties/google";
import {
  ANNIVERSARY_COLLECTION_ID,
  THANK_YOU_COLLECTION_ID,
} from "@/constants/product";

import AnniversaryImg from "@/assets/images/v2/bakers_hero2.webp";
import ThankYouImg from "@/assets/images/v2/thankyou.jpg";

const categories = [
  {
    title: "Anniversary",
    image: AnniversaryImg,
    slug: "anniversary",
    id: ANNIVERSARY_COLLECTION_ID,
  },
  {
    title: "Thank You",
    image: ThankYouImg,
    slug: "thank-you",
    id: THANK_YOU_COLLECTION_ID,
  },
];

const MobileCategories = () => {
  const handleCollectionClick = (collectionName: string) => {
    const formattedName = collectionName.toLowerCase().replace(/ /g, "_");
    sendGAEvent("event", `show_more_${formattedName}_clicked`);
  };

  return (
    <section className={styles.sectionContainer}>
      <div className={styles.gridContainer}>
        {categories.map((cat, index) => (
          <Link
            key={index}
            href={`/listing/${cat.slug}?id=${cat.id}`}
            className={`${styles.imageCard} group cursor-pointer block`}
            onClick={() => handleCollectionClick(cat.title)}
          >
            <ImageComponent
              className={`${styles.cardImage} ${index === 0 ? "scale-[1.15] group-hover:scale-[1.20]" : "group-hover:scale-[1.05]"} transition-transform duration-700`}
              alt={cat.title}
              src={cat.image}
              fill
            />
            <div className={styles.cardOverlay}></div>
            <div className="absolute bottom-4 left-4 flex items-center gap-2">
              <h3 className="text-v2-surface-container-lowest text-lg font-medium font-outfit">
                {cat.title}
              </h3>
              <ArrowRight
                className="size-4 text-v2-surface-container-lowest transition-transform duration-300 group-hover:translate-x-1 mt-0.5"
                strokeWidth={2}
              />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default MobileCategories;
